<template>
  <div>
    <ModalConfirm
      modalId="onShipModal"
      :text="`Are you sure to Force Delivered this order?`"
      :center="true"
      @onClick="changeStatus"
    />
    <TemplateModal :show="showModal" @handleClose="showModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title">Change AWB</p>
        </div>
        <div class="modal-body m-3">
          <div class="row">
            <label class="col-lg-12 col-form-label text-start">
              Current Shipment AWB
            </label>
            <label
              class="col-lg-12 col-form-label text-start text-uppercase"
              style="color: #5e50a1"
            >
              {{ data.airway_bill }}
            </label>
          </div>
          <div class="d-flex flex-column">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Enter New AWB
              </label>
              <div class="col-md-12" v-if="!setAWB">
                <input type="text" v-model="newAWB" class="form-control" />
              </div>
              <label
                v-else
                class="col-lg-12 col-form-label text-start text-uppercase"
                style="color: #5e50a1"
              >
                {{ newAWB }}
              </label>
            </div>
            <span v-if="errors.changeAWB" class="text-danger mt-2">{{
              errors.changeAWB
            }}</span>
          </div>
          <div class="flex mt-5">
            <div
              v-if="!data.service_type?.toUpperCase()?.includes('INSTANT') && data.latest_status && data.latest_status != 'PRJL'"
              class="warning rounded mb-3"
            >
              <img src="@/assets/ic_info_yellow.png" alt="icon-info" />
              <span> Change AWB only available for <b>PRJL</b> status </span>
            </div>
            <div class="warning rounded mb-3" v-if="data.is_dropshipper">
              <img src="@/assets/ic_info_yellow.png" alt="icon-info" />
              <span>
                This is a <b>Dropshipper Order</b>. Please make sure Sender Name
                and Sender Phone Number on the new Printed AWB are as per
                requested, if any.
              </span>
            </div>
            <div class="d-flex col-md-12">
              <div class="col-md-6 me-3">
                <button
                  type="button"
                  class="btn btn-secondary bg-white text-body fw-bold me-1 text-uppercase col-md-11"
                  @click="showModal = false"
                >
                  Cancel
                </button>
              </div>
              <div class="col-md-6 ms-2">
                <button
                  type="button"
                  class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                  v-show="!setAWB"
                  :disabled="(!newAWB || data.latest_status != 'PRJL') && !data.service_type?.toUpperCase()?.includes('INSTANT')"
                  @click="setAWB = true"
                >
                  Change AWB
                </button>
                <button
                  v-show="setAWB"
                  type="button"
                  class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                  @click="changeAWB"
                >
                  Confirm Change AWB
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TemplateModal>
    <div
      class="modal fade"
      id="modalTrackShipment"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title" id="exampleModalLabel">
              Shipment Tracking
            </p>
          </div>
          <div class="modal-body m-2">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Shipment AWB
              </label>
              <label
                class="col-lg-12 col-form-label text-start text-uppercase"
                style="color: #5e50a1"
              >
                {{ awb }}
              </label>
            </div>
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Receiver
              </label>
              <label class="col-lg-12 col-form-label fw-bold text-start">
                {{
                  locationDestination ? locationDestination.address_detail : ""
                }},
                {{ locationDestination ? locationDestination.district : "" }}
                {{ locationDestination ? locationDestination.city : "" }}
                {{ locationDestination ? locationDestination.province : "" }}
              </label>
            </div>
            <div class="row mb-3">
              <GMapMap
                :center="center"
                :zoom="16"
                class="ms-1"
                map-type-id="terrain"
                ref="myMapRef"
                :cluster="{ options: { styles: clusterStyle } }"
                style="width: 460px; height: 200px"
                :options="{
                  fullscreenControl: false,
                  styles: mapStyle,
                  mapTypeControl: false,
                  streetViewControl: false,
                  keyboardShortcuts: false,
                  controlSize: 23,
                }"
              >
                <GMapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :icon="require(`@/assets/images/paxel-marker.svg`)"
                />
              </GMapMap>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h4>History</h4>
                <ul class="timeline">
                  <li v-for="log in logShipment" :key="log">
                    <div class="d-flex">
                      <span class="fw-bold col-md-10 justify-content-start">{{
                        log ? log.status_description : ""
                      }}</span>
                      <div
                        class="d-flex flex-column col-md-2 justify-content-end text-end"
                      >
                        <span>
                          {{ filters.dateAndMonthUtc(log.created_at) }}
                        </span>
                        <span>
                          {{ filters.timeSimpleUtc(log.created_at) }} WIB
                        </span>
                      </div>
                    </div>
                    <p>
                      {{ log.location ? log.location.district : "" }},
                      {{ log.location ? log.location.regency : "" }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:actions="{ data }">
        <div class="d-flex">
          <button
            type="button"
            class="btn btn-light text-danger fw-bold"
            :style="{ height: 'fit-content' }"
            @click="setDataModal(data)"
            data-bs-toggle="modal"
            data-bs-target="#onShipModal"
          >
            Force Delivered
          </button>
          <div class="ms-auto">
            <button
              class="btn"
              v-if="!data.additional_row"
              @click="data.additional_row = !data.additional_row"
            >
              <font-awesome-icon
                icon="fa-solid fa-sort-down"
                class="mb-1 text-warning"
              />
            </button>
            <button
              class="btn mt-3 align-middle"
              v-if="data.additional_row"
              @click="data.additional_row = !data.additional_row"
            >
              <font-awesome-icon
                icon="fa-solid fa-sort-up"
                class="mb-1 text-warning"
              />
            </button>
          </div>
        </div>
      </template>
      <template v-slot:child_order_id="{ data }">
        <div>
          <router-link
            :to="
              '/order/orders/' +
              data.id +
              '?detail=shipment&type_order=orderseller'
            "
            class="text-decoration-none fw-bold"
            style="color: #5e50a1"
          >
            {{ data.id }}
          </router-link>
        </div>
      </template>
      <template v-slot:seller_name="{ data }">
        <div>
          <span class="fw-bold mb-1" style="color: #5e50a1">{{
            data.seller_store_name
          }}</span>
        </div>
      </template>
      <template v-slot:total_order="{ data }">
        <div>
          {{ filters.rupiah(data.order_seller_pricing.total_payment) }}
        </div>
      </template>
      <template v-slot:pickup_request_date="{ value }">
        <div>
          {{ filters.dateFull(value) }}
        </div>
      </template>
      <template v-slot:expiry_date="{ value }">
        <div>
          <span class="text-black-50">
            Automatically Cancelled if Pickup not yet requested by
          </span>
          <br />
          <span class="fw-bold">
            {{ filters.dateSimple(value) }}
          </span>
        </div>
      </template>
      <template v-slot:awb="{ data }">
        <div v-for="order in data.order_packages" :key="order" class="mb-5">
          <span
            v-if="data.service_type.toLowerCase() != 'instant'"
            class="fw-bold"
            style="color: #5e50a1; cursor: pointer"
            data-bs-toggle="modal"
            data-bs-target="#modalTrackShipment"
            @click="checkStatus(order.location_destination, order.airway_bill, data.service_type, order.instant_track_url, order.prev_airway_bill)"
          >
            {{ order.airway_bill }}
          </span>
          <span
            v-else
            class="fw-bold"
            style="color: #5e50a1; cursor: pointer"
            @click="checkStatus(order.location_destination, order.airway_bill, data.service_type, order.instant_track_url, order.prev_airway_bill)"
          >
            {{ order.airway_bill }}
          </span>
          <button id="openModalTrackShipment" v-show="false" data-bs-toggle="modal"
            data-bs-target="#modalTrackShipment"> 
          </button>
          <br />
          <span
            class="fw-bold text-danger"
            style="cursor: pointer"
            data-bs-toggle="modal"
            @click="setDataAWB(data.id, order, data.is_dropshipper, data.service_type)"
          >
            Change AWB
          </span>
          <br />
          <br />
          <span class="text-black-50"> Estimated Time Arrival </span>
          <br />
          <span class="fw-bold">
            {{ arrival(order) }}
          </span>
        </div>
      </template>

      <template v-slot:parent_order_id="{ data }">
        <div>
          <span class="text-black-50"> Parent Order ID </span>
          <br />
          <span class="text-secondary fw-bold">{{ data.order_id }}</span>
        </div>
      </template>
      <template v-slot:location_destination="{ data }">
        <div v-if="data.location_destination">
          <font-awesome-icon
            icon="fa-solid fa-location-dot"
            class="pe-2 text-secondary"
          />
          <span class="fw-bold text-secondary">{{
            data.location_destination.city
          }}</span>
          <br />
          <span class="text-black-50"> Shipment Cost </span>
          <br />
          <span class="fw-bold">{{
            filters.rupiah(data.order_seller_pricing.shipment_cost)
          }}</span>
        </div>
      </template>
      <template v-slot:location_origin="{ data }">
        <div v-if="data.location_origin">
          <font-awesome-icon
            icon="fa-solid fa-location-dot"
            class="pe-2 text-secondary"
          />
          <span class="fw-bold text-secondary">{{
            data.location_origin.city
          }}</span>
          <br />
        </div>
      </template>
      <template v-slot:seller="{ value, data }">
        <div v-if="value">
          <span class="fw-bold" style="color: #5e50a1">{{ value }}</span>
          <br />
          <font-awesome-icon
            icon="fa-solid fa-location-dot"
            class="pe-2 text-secondary"
          />
          <span class="fw-bold text-secondary">{{ data.seller_location }}</span>
        </div>
        <div v-else>
          <font-awesome-icon
            icon="fa-solid fa-location-dot"
            class="pe-2 text-secondary"
          />
          <span class="fw-bold text-secondary">{{ data.seller_location }}</span>
        </div>
      </template>
      <template v-slot:product="{ data }">
        <div>
          <span class="fw-bold mb-1" style="color: #5e50a1">{{
            data.product_items ? `${data.product_items.length} Products` : ""
          }}</span>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import TemplateModal from "@/components/TemplateModal.vue";
import moment from "moment";

export default {
  components: {
    TableBasic,
    ModalConfirm,
    TemplateModal,
  },
  data() {
    return {
      payload: {
        filter: true,
        filterLabel: "Filter by Pickup Req. Date",
        header: [
          {
            key: "child_order_id",
            label: "C. ORDER ID",
            class: "text-start",
          },
          {
            key: "buyer_name",
            label: "BUYER",
            class: "text-start",
          },
          {
            key: "seller_name",
            label: "SELLER",
            class: "text-start",
          },
          {
            key: "total_order",
            label: "TOTAL ORDER",
            class: "text-start",
            sort: true,
            sort_key: "order_seller_pricing.total_payment",
          },
          {
            key: "pickup_request_date",
            label: "PICKUP REQ. DATE",
            class: "text-start",
            sort: true,
            sort_key: "pickup_request_date",
          },
          {
            key: "actions",
            label: "ACTIONS",
            class: "text-start",
          },
        ],
        second_header: [
          {
            key: "parent_order_id",
            label: "Child Order ID",
            class: "text-start",
          },
          {
            key: "location_destination",
            label: "",
            class: "text-start",
          },
          {
            key: "location_origin",
            label: "",
            class: "text-start",
          },
          {
            key: "product",
            label: "",
            class: "text-start",
          },
          {
            key: "",
            label: "",
            class: "",
          },
          {
            key: "awb",
            label: "",
            class: "text-start",
          },
        ],
        value: [],
        totalRows: 1,
        checkbox: true,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 50, 100],
        search: true,
        startDate: "",
        endDate: "",
        new_awb: "",
        searchPlaceholder: "Parent/Child Order ID/Buyer/Seller",
        searchContainerStyle: {
          maxWidth: "235px",
        },
        datepickerOption: {
          autoApply: true,
          timePicker: false,
        },
        sortBy: "",
        sortType: "",
      },
      showModal: false,
      filterValue: {},
      errors: {},
      data: {},
      status: "BEING_DELIVERED",
      newAWB: "",
      setAWB: false,
      id: "",
      mapStyle: [],
      locationDestination: {},
      center: {
        lat: -6.2,
        lng: 106.8456,
      },
      markers: [
        {
          position: {
            lat: -6.2,
            lng: 106.8456,
          },
        },
      ],
      clusterStyle: [
        {
          url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          width: 56,
          height: 56,
          textColor: "#fff",
        },
      ],
      logShipment: [],
      trackUrlExpiredThreshold:5, //in hours
    };
  },
  methods: {
    arrival(order) {
      if (!order?.estimation_arrival_date) return "-";
      return `${this.filters.dateSimple(order.estimation_arrival_date)} | ${
        order.estimation_arrival_min_time
      } - ${order.estimation_arrival_max_time}`;
    },
    changeParameter(value) {
      this.payload.perPage = value.per_page;
      this.payload.currentPage = value.current_page;
      this.payload.sortType = value.sort_type;
      this.payload.sortBy = value.sort_by;
      this.searchInput = value.search;
      this.filterValue = value.filter;
      this.getData();
    },
    async getData() {
      let payload = {
        page: this.payload.currentPage,
        size: this.payload.perPage,
        status: "PICKUP_REQUESTED",
      };

      try {
        if (this.filterValue) {
          payload.date_start = this.filterValue.from;
          payload.date_end = this.filterValue.to;
        }

        if (this.payload.sortBy) payload.sort_by = this.payload.sortBy;
        if (this.payload.sortType) payload.sort_type = this.payload.sortType;

        if (this.searchInput != "") {
          payload.keyword = this.searchInput;
        }

        const response = await this.$store.dispatch(
          "order/getAllOrderSeller",
          payload
        );
        this.payload.value = response.items;
        this.payload.totalRows = response.count;
      } catch (error) {
        console.log("ERROR : ", error);
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        });
      }
    },
    async setDataAWB(id, data, is_dropshipper, service_type) {
      this.errors = {};
      this.showModal = true;
      this.setAWB = false;
      this.newAWB = "";
      this.id = id;
      this.data = {...data, service_type};
      const payload = {
        shipment_code: data.airway_bill,
      };
      try {
        const res = await this.$store.dispatch(
          "order/getShipmentStatus",
          payload
        );
        const shipmentData = res.data[0];
        this.data.latest_status = shipmentData.latest_status;
        this.data.is_dropshipper = is_dropshipper;
      } catch (err) {
        console.log(err);
      }
    },
    setDataModal(data) {
      this.data = data;
    },
    async changeStatus() {
      const payload = {
        order_seller_id: this.data.id,
      };

      await this.$store.dispatch("order/forceDeliveredOrderSeller", payload);

      setTimeout(() => {
        /* https://pmtools.paxel.co/issues/244 disable auto redirect to next status, refresh table data only */
        // this.$router.push("/order/orders?status=Delivered");
        this.getData();
      }, 500);
    },
    async changeAWB() {
      const payload = {
        order_seller_id: this.id,
        new_airway_bill: this.newAWB,
        old_airway_bill: this.data.airway_bill,
      };

      try {
        await this.$store.dispatch("order/changeOrderAWB", payload);
        this.errors = {};
        this.showModal = false;
        setTimeout(() => {
          window.location.reload(true);
        }, 500);
      } catch (error) {
        console.log("ERROR : ", error);
        this.errors = { changeAWB: "Invalid AWB" };
        this.setAWB = false;
      }
    },
    async checkStatus(destination, awb, service_type,instant_track_url, prev_airway_bill ) {
      this.awb = awb;
      this.locationDestination = destination;
      this.center = {
        lat: destination.lat_lng[0],
        lng: destination.lat_lng[1],
      };

      this.markers = [
        {
          position: {
            lat: destination.lat_lng[0],
            lng: destination.lat_lng[1],
          },
        },
      ];

      const payload = {
        shipment_code: awb,
      };
      try {
        this.shipment = await this.$store.dispatch(
          "order/getShipmentStatus",
          payload
        );
        const logShipment = this.$store.getters["order/ShipmentLogs"];
        this.logShipment =
          logShipment.length > 0 ? logShipment : this.logShipment;
        if(service_type.toLowerCase() == 'instant'){
          this.checkIsUrlExpired(instant_track_url,prev_airway_bill)
        }
      } catch (err) {
        console.log(err);
      }
    },
    showTrackUrl(instant_track_url){
      //if available open webview track shipment
      if(instant_track_url){
        window.open(instant_track_url, "_blank")
      }else{
        //if not availalbe show alert info, because its posible shipment was created but system still looking for driver, so track url still unavailable
        this.$swal({
          title: "Lacak paket belum tersedia",
          icon: "warning",
          timer: 2000,
        });
      }
    },
    checkIsUrlExpired(instant_track_url, prev_airway_bill){
      let log = this.logShipment;
      //check order is ever use change awb? if it was, show default tracking (because webhook for new track url was not updated)
      if(prev_airway_bill == null){
        //find selected data by shipment code
        let find =  log.find(o => o.status === 'COL');
        if(find){
          let current_time = moment(new Date).unix();
          let threshold_time = moment.utc(find.created_at).add(this.trackUrlExpiredThreshold,'hours').unix();
          console.log(current_time,threshold_time )
          //compare current time and time shipping saved the track url, and check is expired or not
          if(current_time > threshold_time){
            //if already expired, show existing function to show history
            document.getElementById("openModalTrackShipment")?.click()
          }else{
            //if not expired, show webview to track shipment from gosend
            this.showTrackUrl(instant_track_url)
          }
        }else{
          //mean status log not yet reach to COL or track url not saved yet in db
          document.getElementById("openModalTrackShipment")?.click()
        }
      }else{
        document.getElementById("openModalTrackShipment")?.click()
      }
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.warning {
  border: 1px solid #ffb003 !important;
  background-color: #ffe9b9;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 28px;
  padding: 3px 12px;
}
.error-border {
  border: 1px red solid !important;
}

ul.timeline {
  list-style-type: none;
  position: relative;
}

ul.timeline:before {
  content: " ";
  background: #56c378;
  display: inline-block;
  position: absolute;
  left: 29px;
  width: 2px;
  height: 100%;
  z-index: 400;
}

ul.timeline > li {
  margin: 20px 0;
  padding-left: 20px;
}

ul.timeline > li:before {
  font-family: "Font Awesome 5 Free";
  content: "\f00c";
  font-weight: 600;
  background: white;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  color: #56c378;
  border: 2px solid #56c378;
  padding-left: 2px;
  left: 20px;
  width: 20px;
  height: 20px;
  z-index: 400;
}
</style>
